import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import { ONE_APP_ICON_UPDATE } from 'constants/featureToggleNames';
import MobileAppIcon from './MobileAppIcon';
import styles from './MobileAppIcon.styles';

export default compose(
  withFeatureToggles({
    isOneAppIconEnabled: ONE_APP_ICON_UPDATE,
  }),
  withStyles(styles),
)(MobileAppIcon);
